import { useMediaQuery } from "react-responsive";

import { HeaderLogo } from "components/shared/logo-link";
import { screenSizes } from "consts";

import styles from "./desktop-header.module.scss";
import { Navigation } from "./navigation";
import { ProfileDropdown } from "./profile-dropdown";

type DesktopHeaderProps = {
  hideNavigation?: boolean;
};

export const DesktopHeader = ({ hideNavigation }: DesktopHeaderProps) => {
  const isLaptop = useMediaQuery({
    maxWidth: screenSizes.laptopL,
    minWidth: screenSizes.laptop,
  });

  return (
    <div className={styles.headerContainer}>
      <div className={styles.primaryHeader} data-testid="primary-header">
        <div className={styles.logoNavWrapper}>
          <HeaderLogo logo={isLaptop ? "icon" : "default"} />
          {!hideNavigation ? (
            <div className={styles.mainNavigation}>
              <Navigation />
            </div>
          ) : null}
        </div>
        {!hideNavigation ? <div className={styles.divider} /> : null}
        <div className={styles.profileDropdown}>
          <ProfileDropdown />
        </div>
      </div>
    </div>
  );
};
